<template>
   <li class="clr-select-dropdown__item selected hover" @click.stop="clickAction" v-show="!isHide"><span>{{label}}</span></li>
</template>

<script>
export default {
  name: "lrInput",
  props: {
    label: { type: String, default: '' },
  },
  data() {
    return {
    };
  },
  computed: {
    isHide() {
      return this.$parent.resList.includes(this.label)
    }
  },
  watch: {
    
  },
  mounted() {
    this.$parent.allList.push(this.label)    
  },
  methods: {
    clickAction() {
      this.$parent.optionClickAction(this.label)
    }
  },
};
</script>

<style scoped  lang="scss">
.clr-select-dropdown__item {
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/LrSelectInput/option.vue